import React, { useEffect, useState } from 'react';
import { generateBlogSitemap } from '@/utils/enhancedSitemap';

const BlogSitemap: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const serveSitemap = async () => {
      try {
        const response = await fetch('https://lusickipehpranrjynvx.supabase.co/functions/v1/blog-sitemap');
        const xml = await response.text();
        
        document.open();
        document.write(xml);
        document.close();
        
        setLoading(false);
      } catch (error) {
        console.error('Error fetching sitemap:', error);
        document.body.innerHTML = 'Error loading sitemap';
        setLoading(false);
      }
    };

    serveSitemap();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        fontFamily: 'monospace', 
        whiteSpace: 'pre-wrap', 
        padding: '20px',
        fontSize: '12px'
      }}>
        Generating blog sitemap...
      </div>
    );
  }

  return null;
};

export default BlogSitemap;